export default __webpack_public_path__ + "static/media/fisica.bcc0aa49.svg";